var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoMasterCard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 13,
    viewBox: "0 0 20 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1388_223116)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.26172 1.78125H12.9407V11.2146H7.26172V1.78125Z",
    fill: "#F26122"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.078 11.217C9.04898 12.0469 7.76693 12.4997 6.44496 12.5C5.66417 12.4931 4.89239 12.3323 4.17374 12.027C3.45509 11.7217 2.80365 11.2777 2.25666 10.7205C1.70966 10.1633 1.27783 9.50376 0.985845 8.77958C0.69386 8.05541 0.547443 7.28079 0.554963 6.5C0.547575 5.71925 0.694082 4.94469 0.986114 4.22057C1.27815 3.49645 1.70998 2.83696 2.25695 2.27978C2.80392 1.72259 3.45531 1.27863 4.1739 0.97325C4.89249 0.66787 5.66421 0.507058 6.44496 0.5C7.76696 0.5 9.04896 0.953 10.078 1.783C9.37711 2.35321 8.81213 3.07244 8.4241 3.88838C8.03607 4.70433 7.83473 5.59649 7.83473 6.5C7.83473 7.40351 8.03607 8.29567 8.4241 9.11162C8.81213 9.92756 9.37711 10.6468 10.078 11.217Z",
    fill: "#EA1D25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.6177 6.5C19.6251 7.28075 19.4786 8.05531 19.1866 8.77943C18.8946 9.50355 18.4627 10.163 17.9158 10.7202C17.3688 11.2774 16.7174 11.7214 15.9988 12.0267C15.2802 12.3321 14.5085 12.4929 13.7277 12.5C12.4055 12.4998 11.123 12.0471 10.0938 11.217C10.7944 10.6467 11.3593 9.92742 11.7472 9.11149C12.1351 8.29556 12.3364 7.40345 12.3364 6.5C12.3364 5.59655 12.1351 4.70444 11.7472 3.88851C11.3593 3.07258 10.7944 2.35332 10.0938 1.783C11.1227 0.953064 12.4048 0.500308 13.7268 0.5C14.5076 0.506797 15.2795 0.667423 15.9983 0.972698C16.717 1.27797 17.3686 1.72191 17.9157 2.27914C18.4628 2.83636 18.8947 3.49594 19.1868 4.22019C19.4788 4.94443 19.6253 5.71913 19.6177 6.5Z",
    fill: "#F69E1E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1388_223116"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 12,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoMasterCard);
export default __webpack_public_path__ + "static/media/logo_master_card.d0e7214873fff2e831bb53a4c211da12.svg";
export { ForwardRef as ReactComponent };